import { render, staticRenderFns } from "./orderSellList.vue?vue&type=template&id=3656bb34&scoped=true"
import script from "./orderSellList.vue?vue&type=script&lang=js"
export * from "./orderSellList.vue?vue&type=script&lang=js"
import style0 from "./orderSellList.vue?vue&type=style&index=0&id=3656bb34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3656bb34",
  null
  
)

export default component.exports